/**
 * Parse a date string from the backend.
 *
 * MySQL DATETIME columns return strings like "2026-04-24 14:30:00" with no timezone
 * info. JavaScript's `new Date()` interprets such strings as **local time**, which
 * is wrong when the DB stores in UTC (Aurora RDS default). The user then sees the
 * timestamp shifted by their local timezone offset (e.g. "il y a 2h" for a message
 * just sent, in UTC+2).
 *
 * This helper appends 'Z' to bare MySQL DATETIME strings so JS parses them as UTC,
 * then displays them correctly in the user's local timezone via `toLocale*` calls.
 */
export function parseServerDate(dateStr) {
    if (!dateStr) return null;
    let s = String(dateStr);
    // Match "YYYY-MM-DD HH:MM:SS" or "YYYY-MM-DDTHH:MM:SS" with no timezone suffix.
    if (/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}$/.test(s)) {
        s = s.replace(' ', 'T') + 'Z';
    }
    return new Date(s);
}
